module.exports = JSON.parse('{"Copied":"Gekopieerd","Failed to copy":"Kopiëren mislukt"}')